module.exports = __webpack_public_path__ + "img/mgh-otemachi-sp@2x.ed404f10.jpg";